import { SOCIAL_AD_TYPES } from "utils/constants";
import { mapStringToOption } from "social/utils";

/* eslint-disable quote-props */
export const FACEBOOK_CTA_IDS = {
	"Apply Now": "APPLY_NOW",
	"Book Now": "BOOK_TRAVEL",
	// "Buy Tickets": "BUY_TICKETS",
	// "Call Now": "CALL_NOW",
	"Contact Us": "CONTACT_US",
	"Donate Now": "DONATE_NOW",
	"Download": "DOWNLOAD",
	// "Get Directions": "GET_DIRECTIONS",
	"Get Offer": "GET_OFFER",
	"Get Quote": "GET_QUOTE",
	"Get Showtimes": "GET_SHOWTIMES",
	// "Install Now": "INSTALL_APP",
	"Learn More": "LEARN_MORE",
	// "Like Page": "LIKE_PAGE",
	"Listen Now": "LISTEN_NOW",
	"Request Time": "REQUEST_TIME",
	// "Save": "SAVE",
	"See Menu": "SEE_MENU",
	"Send Message": "SEND_MESSAGE",
	// "Send WhatsApp Message": "WHATSAPP_MESSAGE",
	"Shop Now": "SHOP_NOW",
	"Sign Up": "SIGN_UP",
	"Subscribe": "SUBSCRIBE",
	"Watch More": "WATCH_MORE",
	"Order Now": "ORDER_NOW",
	"Get Access": "PAY_TO_ACCESS",
	"Get Promotions": "GET_PROMOTIONS",
	"Get Updates": "SEND_UPDATES",
	"No Button": "NO_BUTTON",
	"Open Link": "OPEN_LINK",
	"Play Game": "PLAY_GAME",
	"Start Order": "START_ORDER",
	"Explore More": "EXPLORE_MORE",
	"Install Now": "INSTALL_MOBILE_APP",
	"Use App": "USE_APP",
};
/* eslint-enable quote-props */

export const FACEBOOK_CTAS = Object.keys(FACEBOOK_CTA_IDS);

export const SNAPCHAT_CTAS = [
	"Apply Now",
	"Book Now",
	"Buy Tickets",
	"Donate",
	"Download",
	"Get Now",
	"Listen",
	"More",
	"Order Now",
	"Play",
	"Play Game",
	"Pre-Register",
	"Read",
	"Shop Now",
	"Show",
	"Showtimes",
	"Sign Up",
	"View",
	"View Menu",
	"Vote",
	"Watch",
];

export const LINKEDIN_CTAS = [
	"Apply Now",
	"Download",
	"Learn More",
	"Register",
	"Sign Up",
	"Subscribe",
	"View Quote",
];

export const TIKTOK_CTAS = [
	"Apply Now",
	"Book Now",
	"Contact Us",
	"Download",
	"Experience Now",
	"Get Quote",
	"Get Showtimes",
	"Get Tickets Now",
	"Install Now",
	"Interested",
	"Learn More",
	"Listen Now",
	"Order Now",
	"Play Game",
	"Pre-Order Now",
	"Read More",
	"Shop Now",
	"Sign Up",
	"Subscribe",
	"View Now",
	"Visit Store",
	"Watch Now",
];

export const CTAS_BY_ADTYPE = {
	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE]: FACEBOOK_CTAS,
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO]: FACEBOOK_CTAS,

	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE_MO]: FACEBOOK_CTAS,
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO]: FACEBOOK_CTAS,

	[SOCIAL_AD_TYPES.SNAPCHAT_IMAGE]: SNAPCHAT_CTAS,
	[SOCIAL_AD_TYPES.SNAPCHAT_VIDEO]: SNAPCHAT_CTAS,

	[SOCIAL_AD_TYPES.LINKEDIN_VIDEO]: LINKEDIN_CTAS,

	[SOCIAL_AD_TYPES.TIKTOK_VIDEO]: TIKTOK_CTAS,
};

export const FB_CTA_OPTIONS = FACEBOOK_CTAS.map(mapStringToOption);
